export default {
	site_name: 'democratic_mayors',
};
